import React, { useContext, useMemo, useState } from 'react';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ALL_MESSAGES, ON_MESSAGE_CHANGED } from '../../graphql/messages';
import BaseUrlContext from '../../contexts/BaseUrlContext';
import MessagesList from './MessagesList';
import Paginator from '../Paginator';
import { parsePaging } from '../../utils/queryString';
import Spinner from '../Spinner';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import CreateMessageRow from './CreateMessageRow';
import Error from '../errors/Error';
import useExtendedQuery from '../../hooks/useExtendedQuery';

function Messages() {
    const location = useLocation();
    const history = useHistory();
    const baseUrl = useContext(BaseUrlContext);
    const { t } = useTranslation();
    const { page, perPage } = parsePaging(location.search);
    const [currentPage, setCurrentPage] = useState(page);
    const variables = useMemo(() => ({
        sortOrder: 'desc',
        page: currentPage,
        perPage,
    }), [currentPage, perPage]);
    const {
        loading,
        error,
        data,
        refetch,
    } = useExtendedQuery(ALL_MESSAGES, {
        variables,
        variablesToUrl: false,
    });
    const onPageChange = (toPage) => {
        setCurrentPage(toPage);
        history.push(`${baseUrl}?${qs.stringify({ page: toPage, perPage })}`);
        refetch({ sortOrder: 'desc', page: toPage, perPage });
    };
    useExtendedSubscription(ON_MESSAGE_CHANGED, {
        refetch,
        refetchVariables: variables,
        dataProperty: 'messageChanged',
    });
    let result;
    if (loading) {
        result = <Spinner className="messages-loading" />;
    } else if (error) {
        result = <Error className="messages-error" error={error} />;
    } else {
        result = (
            <Paginator
                totalCount={data.allMessages.totalCount}
                perPage={perPage}
                currentPage={currentPage}
                onPageChange={onPageChange}
                bottom
            >
                <MessagesList messages={data.allMessages.models} />
            </Paginator>
        );
    }
    return (
        <>
            <h4><FontAwesomeIcon icon="envelope" />&nbsp;{t('title.messages')}</h4>
            <CreateMessageRow />
            {result}
        </>
    );
}

export default Messages;
